import React from 'react';

const Contact = () => {
    return <h2>Contact Page</h2>;
};

export default Contact;
